import { Component, Input, OnInit } from '@angular/core';
import { Options } from '@angular-slider/ngx-slider';
import { UntypedFormGroup } from '@angular/forms';

@Component({
    selector: 'app-percentage-cover',
    templateUrl: './percentage-cover.component.html',
    styleUrls: ['./percentage-cover.component.scss'],
    standalone: false,
})
export class PercentageCoverComponent implements OnInit {
    @Input() cssClass;
    @Input() form: UntypedFormGroup;
    @Input() enable: boolean;

    tooltip_position = 'above';
    vertical = false;
    value: number = 100;
    options: Options = {
        showTicksValues: true,
        stepsArray: [{ value: 25 }, { value: 33 }, { value: 50 }, { value: 100 }],
    };

    ngOnInit(): void {
        this.form.markAllAsTouched();
        if (this.form !== null) {
            let pCover = this.form.get('percentageCover').value;
            this.value = pCover === null ? 100 : pCover;
        }
    }
}
